"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerStatusAdvantagesToJSON = exports.CustomerStatusAdvantagesFromJSONTyped = exports.CustomerStatusAdvantagesFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function CustomerStatusAdvantagesFromJSON(json) {
    return CustomerStatusAdvantagesFromJSONTyped(json, false);
}
exports.CustomerStatusAdvantagesFromJSON = CustomerStatusAdvantagesFromJSON;
function CustomerStatusAdvantagesFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'list': !(0, runtime_1.exists)(json, 'list') ? undefined : json['list'],
        'links': !(0, runtime_1.exists)(json, 'links') ? undefined : (json['links'].map(_1.CustomerStatusAdvantagesLinksFromJSON)),
    };
}
exports.CustomerStatusAdvantagesFromJSONTyped = CustomerStatusAdvantagesFromJSONTyped;
function CustomerStatusAdvantagesToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'list': value.list,
        'links': value.links === undefined ? undefined : (value.links.map(_1.CustomerStatusAdvantagesLinksToJSON)),
    };
}
exports.CustomerStatusAdvantagesToJSON = CustomerStatusAdvantagesToJSON;
//# sourceMappingURL=CustomerStatusAdvantages.js.map